import {
  GroupLearningPathModuleFlagEnum,
  isGroupLearningPathModuleFlag,
} from "../../../Enums/GroupLearningPathModuleFlagEnum";
import { isModuleResponseDTO, ModuleResponseApi } from "../Module/Module";
import {
  isModuleResourceWithStudentProgressResponseDTO,
  ModuleResourceWithStudentProgressResponseApi,
} from "./ModuleResourceWithStudentProgress";

export interface GroupModuleResponseApi {
  groupModuleId: string;
  groupModuleOrder: number;
  groupLearningPathModuleFlag: GroupLearningPathModuleFlagEnum;
  learningPathModule: {
    // TODO: collapse property
    module: ModuleResponseApi & {
      moduleResources: ModuleResourceWithStudentProgressResponseApi[];
    };
  };
}

export let isGroupModuleResponseDTO = (
  variable: unknown
): variable is GroupModuleResponseApi => {
  return (
    variable !== undefined &&
    variable !== null &&
    typeof variable === "object" &&
    "groupModuleId" in variable &&
    typeof variable.groupModuleId === "string" &&
    "groupModuleOrder" in variable &&
    typeof variable.groupModuleOrder === "number" &&
    "groupLearningPathModuleFlag" in variable &&
    isGroupLearningPathModuleFlag(variable.groupLearningPathModuleFlag) &&
    "learningPathModule" in variable &&
    typeof variable.learningPathModule === "object" &&
    variable.learningPathModule !== null &&
    "module" in variable.learningPathModule &&
    isModuleResponseDTO(variable.learningPathModule.module) &&
    "moduleResources" in variable.learningPathModule.module &&
    Array.isArray(variable.learningPathModule.module.moduleResources) &&
    (variable.learningPathModule.module.moduleResources.length === 0 ||
      variable.learningPathModule.module.moduleResources.reduce(
        (doArrayConsistOfResources, moduleResource) =>
          doArrayConsistOfResources &&
          isModuleResourceWithStudentProgressResponseDTO(moduleResource)
      ))
  );
};
